export default __webpack_public_path__ + "static/media/welcome-nextsong.8fab7c5f.png";